import { render } from "./formcheckbox.vue?vue&type=template&id=a043bc92"
import script from "./formcheckbox.vue?vue&type=script&lang=js"
export * from "./formcheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__